// tslint:disable:max-line-length
import * as React from 'react';

import { BuildingAreaIcon } from '../../ui/icon/icons/building-area';
import { BuiltAreaIcon } from '../../ui/icon/icons/built-area';
import { BuiltFlatsIcon } from '../../ui/icon/icons/built-flats';
import { FamiliesLivingIcon } from '../../ui/icon/icons/families-living';
import { KindergartenIcon } from '../../ui/icon/icons/kindergarten';
import { RegionIcon } from '../../ui/icon/icons/region';
import { ReliabilityIcon } from '../../ui/icon/icons/reliability';
import { SchoolsIcon } from '../../ui/icon/icons/schools';

export const main: { text: string; strong?: string }[] = [
  {
    text: `ПИК — крупнейший российский девелопер. Компания с 1994 года возводит жилые районы в Москве и других городах России, включая Санкт-Петербург, Тюмень и Екатеринбург. ПИК строит не только дома, но и детские сады, школы, поликлиники, а также создаёт пространства для спорта и отдыха.`,
  },
  {
    text: `Все проекты возводятся по единому стандарту качества. ПИК-Стандарт — это благоустроенные дворы-парки, подъезды на уровне земли, продуманная квартальная застройка, дома разной высоты и увеличенные окна, чтобы в каждой квартире было максимум солнечного света каждый день.`,
  },
  {
    text: `ПИК разрабатывает и реализует самые современные IT-решения на российском рынке. Мы первый и единственный девелопер в России, с которым покупку объекта недвижимости — квартиры, кладового помещения и машиноместа — можно полностью провести дистанционно, вплоть до оплаты банковской картой онлайн.`,
  },
];

export const facts: { icon?: React.SFC<{ iconClassName?: string }>; title?: string; text?: string }[][] = [
  [
    {
      icon: BuiltAreaIcon,
      text: 'построено\u00a0с\u00a0начала деятельности',
      title: '25\u00a0млн\u00a0м²',
    },
    {
      icon: RegionIcon,
      text: 'крупнейший регион присутствия',
      title: 'Москва и обл.',
    },
    {
      icon: BuiltFlatsIcon,
      text: 'построено\u00a0с\u00a0начала деятельности',
      title: '500\u00a0000 квартир',
    },
    {
      icon: BuildingAreaIcon,
      text: 'Стоимость земельного банка ПИК на\u00a031\u00a0декабря 2019\u00a0г.',
      title: '426,5\u00a0млрд рублей',
    },
  ],
  [
    {
      icon: ReliabilityIcon,
      text: 'рейтинг\u00a0кредитоспособности АКРА А- (самый высокий среди российских девелоперов)',
      title: 'Надёжность',
    },
    {
      icon: FamiliesLivingIcon,
      text: 'проживают в квартирах от ПИК',
      title: 'Более 1,5\u00a0млн человек',
    },
    {
      icon: KindergartenIcon,
      text: 'построено с января 2014 по август 2019 г.',
      title: '19 школ и 44 детских сада',
    },
    {
      icon: SchoolsIcon,
      text: 'обеспечено в детских образовательных учреждениях столичного региона с января 2014 по август 2019 г.',
      title: '22\u00a0000 мест',
    },
  ],
];

export const history: { text: string; year: number }[] = [
  {
    text: 'Создание «Первой Ипотечной Компании» (ПИК)',
    year: 1994,
  },
  {
    text: 'Запуск ипотечных программ совместно с\u00a0Правительством Москвы и\u00a0банками-партнёрами',
    year: 1998,
  },
  {
    text: 'Приобретение московского Домостроительного комбината\u00a0№2 (ДСК\u00a0−\u00a02)',
    year: 2001,
  },
  {
    text: 'Выход на рынки\u00a0Московской и\u00a0Ростовской областей',
    year: 2004,
  },
  {
    text: 'Приобретение московского Домостроительного комбината\u00a0№3 (ДСК\u00a0−\u00a03)',
    year: 2005,
  },
  {
    text:
      'Выход на\u00a0международный финансовый рынок: успешное первичное размещение акций на\u00a0Лондонской Фондовой бирже (LSE), РТС и\u00a0ММВБ',
    year: 2007,
  },
  {
    text: 'Получение государственных гарантий Правительства Российской Федерации',
    year: 2009,
  },
  {
    text:
      'Получение индивидуального рейтинга кредитоспособности на\u00a0уровне «А» от\u00a0Национального рейтингового агентства\u00a0(НРА)',
    year: 2012,
  },
  {
    text:
      'ПИК признан лучшим девелопером жилой недвижимости в\u00a0России по\u00a0версии британского журнала Euromoney',
    year: 2014,
  },
  {
    text:
      'Вывод на\u00a0рынок принципиально новых типов домов с\u00a0улучшенными эстетическими и\u00a0потребительскими характеристиками',
    year: 2015,
  },
  {
    text: 'ПИК приобрел ГК\u00a0«Мортон» и\u00a0стал лидером строительной отрасли',
    year: 2016,
  },
  {
    text: 'Построены\u00a0рекордные\u00a02\u00a0млн\u00a0м² (29 000 квартир)',
    year: 2017,
  },
  {
    text: 'Компания запустила первый проект в\u00a0новом регионе — «Озёрный парк» в\u00a0Тюмени.',
    year: 2018,
  },
  {
    text: 'Впервые на\u00a0российском рынке введена онлайн-оплата покупки недвижимости банковской картой',
    year: 2019,
  },
];
